module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15.09' height='15.26' viewBox='0 0 15.09 15.26'%3E %3Cpath id='Rectangle_578_copy_4' data-name='Rectangle 578 copy 4' d='M1718.91,58.1V54.94h3.12V58.1Zm-5.97,0V54.94h3.19V58.1Zm-6,0V54.94h3.16V58.1Zm11.96-5.99V48.92h3.12v3.19Zm-5.9-.01V48.91h3.12V52.1Zm-6.06-.07V48.91h3.16v3.12Zm11.97-5.97V42.84h3.12v3.22Zm-5.97,0V42.84h3.19v3.22Zm-6,0V42.84h3.16v3.22Z' transform='translate(-1706.94 -42.84)' fill='%23626262'/%3E %3C/svg%3E"


//////////////////
// WEBPACK FOOTER
// ./src/assets/platform_gray.svg
// module id = 2024
// module chunks = 0